import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  public router: Router;
  public breadcrumbPaths = [{ "name": 'Forside', "link": '/' }];
  public isCurrentRoute = false;
  public isMobile: boolean;

  private readonly clientService: ClientService;

  constructor(router: Router, clientService: ClientService) 
  {
    this.router = router;
    this.clientService = clientService;
  }

  public ngOnInit(): void 
  {
    this.createBreadCrumbs();
    this.isMobile = this.clientService.checkForMobileView();
  }

  public createBreadCrumbs(): void
  {
    const currentRoute = location.href.split('/').slice(3);

    for(let i = 0; i < currentRoute.length; i++ ) {
        const route = currentRoute[i];
        const name = route.toLowerCase().replace(/-/g,' ');
        const nameWithoutQuerystring = name.split("?")[0];
        const link = '/' + currentRoute.slice( 0, i + 1 ).join('/');
        const linkWithoutQuerystring = link.split("?")[0];
        this.breadcrumbPaths.push({ "name": nameWithoutQuerystring, "link": linkWithoutQuerystring });
    }
  }

  public navigateToRoute(breadcrumbLink: string): void
  {

    if(breadcrumbLink === '/'){
      window.location.href="/";
    }else {
      this.router.navigateByUrl(breadcrumbLink);
    }
  }
}
